import * as React from 'react'
import Navigation from './navigation'

const App: React.FC = () => {
  return <Navigation />
}

export default App
